import { apiFetch, companyHeader, API_BASE_URL } from './prospects.js';

export function productImageUrl(product) {
  const id = product?._id || product?.id;
  if (!id) return '';
  if (!product?.imageKey) {
    return String(product?.imageUrl || '').trim();
  }

  const params = new URLSearchParams();
  const cacheKey =
    product?.updatedAt ||
    product?.imageKey ||
    product?.imageOriginalName ||
    '';
  if (cacheKey) params.set('v', String(cacheKey));
  if (product?.companyId) params.set('c', String(product.companyId));
  const qs = params.toString();
  return `${API_BASE_URL}/products/${encodeURIComponent(id)}/image${
    qs ? `?${qs}` : ''
  }`;
}

export async function fetchProducts() {
  return apiFetch('/products');
}

export async function fetchProductById(id) {
  return apiFetch(`/products/${id}`);
}

export async function createProduct(data) {
  return apiFetch('/products', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function updateProduct(id, data) {
  return apiFetch(`/products/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}

export async function deleteProduct(id) {
  return apiFetch(`/products/${id}`, {
    method: 'DELETE',
  });
}

export async function uploadProductImage(id, file) {
  const form = new FormData();
  form.append('file', file);
  return apiFetch(`/products/${id}/image`, {
    method: 'POST',
    body: form,
  });
}
